import { Tag } from '@strata/react-tags';

interface ProductLabelProps {
    product?: string;
    isBrand: boolean;
}

export const ProductLabel = ({ product = undefined, isBrand }: ProductLabelProps) => (
    <div className="flex__gap--medium" style={{ alignItems: 'center' }}>
        <span>{product}</span>
        {isBrand && <Tag label="Brand" style={{ flexShrink: 0 }} />}
    </div>
);
